<template>
  <div class="table">
    <el-table
      :data="tableData"
      style="width: 100%"
      id="tableCon1"
      border
      height="70vh"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        label="描述内容"
        align="center"
        prop="content"
      ></el-table-column>
      <el-table-column prop="typeName" label="类型" align="center">
      </el-table-column>
      <el-table-column prop="placeName" label="所属园区" align="center">
      </el-table-column>
      <el-table-column prop="placeName" label="位置" align="center">
      </el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        align="center"
        v-if="type == 1 || type == 2"
      >
        <template slot-scope="{ row }">
          <div v-if="row.state == 1">待处理</div>
          <div v-if="row.state == 2">已处理</div>
          <div v-if="row.state == 3">已评价</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="empName"
        label="提交人"
        align="center"
        v-if="type == 1"
      >
      </el-table-column>
      <el-table-column
        prop="empNo"
        label="提交人工号"
        align="center"
        show-overflow-tooltip
        v-if="type == 1"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="提交时间"
        align="center"
        show-overflow-tooltip
        v-if="type == 1"
      >
      </el-table-column>
      <el-table-column
        prop="disposeName"
        label="处理人"
        align="center"
        v-if="type == 2"
      >
      </el-table-column>
      <el-table-column
        prop="disposeNo"
        label="处理人工号"
        align="center"
        show-overflow-tooltip
        v-if="type == 2"
      ></el-table-column>
      <el-table-column
        prop="disposeTime"
        label="处理时间"
        align="center"
        show-overflow-tooltip
        v-if="type == 2"
      >
      </el-table-column>
      <el-table-column
        prop="empName"
        label="提交人"
        align="center"
        v-if="type == 3"
      >
      </el-table-column>
      <el-table-column
        prop="disposeName"
        label="处理人"
        align="center"
        v-if="type == 3"
      >
      </el-table-column>
      <el-table-column
        prop="evaluateScore"
        label="评价分数"
        align="center"
        v-if="type == 3"
      >
      </el-table-column>
      <el-table-column
        prop="evaluate"
        label="评价内容"
        align="center"
        v-if="type == 3"
      >
      </el-table-column>
      <el-table-column
        prop="evaluateTime"
        label="评价时间"
        align="center"
        :show-overflow-tooltip="true"
        v-if="type == 3"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "causallyPushTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    console.log("asdasd");
  },
  methods: {
    // 详情
    handleDetail(row, type) {
      console.log(row, "row");
      this.$router.push({
        path: "/causallyPush/detail",
        query: {
          type: type,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.s1 {
  color: rgba(78, 162, 124, 1);
}

.s2 {
  color: rgba(254, 96, 96, 1);
}

.tablecolumn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 5px;

  img {
    width: 30px;
    height: 35px;
    // margin-left: 10px;
  }
}

.table {
  border: 1px solid #ccc;
  width: 100%;
}

::v-deep {
  .el-table th.el-table__cell {
    background: #f5f7fa !important;
  }
  .green {
    background: #84d4be !important;
    color: #000 !important;
  }
  .red {
    background: #fdb0b0 !important;
    color: #000 !important;
  }
  .yellow {
    background: #ffdd8f !important;
    color: #000 !important;
  }
  .lastColor {
    background: rgb(171, 228, 217) !important;
    /* 如果需要，调整底部行的背景颜色 */
    color: rgba(51, 51, 51, 1) !important;
  }

  .el-table thead.is-group th.el-table__cell {
    background: rgba(231, 240, 240, 1);
  }

  // thead {
  //   tr:nth-child(2) {
  //     th {
  //       background: rgb(171, 228, 217) !important;
  //     }
  //   }
  // }
  .cell {
    // height: 22px;
    // line-height: 22px;
    padding: 10px 0;
  }
  th {
    .cell {
      padding: 20px 0;
    }
  }
  .el-table__cell {
    border-color: #ccc !important;
    color: #000;
    font-size: 26px !important;
    // background: rgba(231, 240, 240, 1);
    padding: 0;
  }

  .el-table__body {
    width: 100% !important;
    // 选中最后一行tr
    tr:last-child {
      td {
        // background: rgb(171, 228, 217) !important;
      }
    }
  }

  .el-table th.gutter {
    display: none;
    width: 0;
  }

  .el-table colgroup col[name="gutter"] {
    display: none;
    width: 0;
  }

  .el-table--scrollable-y .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  // tbody {
  //   tr:last-child {
  //     position: sticky;
  //     bottom: 0;
  //     z-index: 1; /* 保证底部行位于表格内容之上 */
  //     td {
  //       background: rgb(
  //         171,
  //         228,
  //         217
  //       ) !important; /* 如果需要，调整底部行的背景颜色 */
  //       color: rgba(51, 51, 51, 1) !important;
  //     }
  //   }
  // }
}
</style>
